<template>
  <div>
      <add-customer-component/>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>